/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Signup
 */
export interface Signup {
    /**
     * 
     * @type {string}
     * @memberof Signup
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof Signup
     */
    passwordConfirm: string;
    /**
     * 
     * @type {string}
     * @memberof Signup
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Signup
     */
    hash: string;
}

/**
 * Check if a given object implements the Signup interface.
 */
export function instanceOfSignup(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "passwordConfirm" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "hash" in value;

    return isInstance;
}

export function SignupFromJSON(json: any): Signup {
    return SignupFromJSONTyped(json, false);
}

export function SignupFromJSONTyped(json: any, ignoreDiscriminator: boolean): Signup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
        'passwordConfirm': json['password_confirm'],
        'email': json['email'],
        'hash': json['hash'],
    };
}

export function SignupToJSON(value?: Signup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
        'password_confirm': value.passwordConfirm,
        'email': value.email,
        'hash': value.hash,
    };
}

